import { render, staticRenderFns } from "./open_node_management.vue?vue&type=template&id=982074f6&scoped=true"
import script from "./open_node_management.vue?vue&type=script&lang=js"
export * from "./open_node_management.vue?vue&type=script&lang=js"
import style0 from "./open_node_management.vue?vue&type=style&index=0&id=982074f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982074f6",
  null
  
)

export default component.exports